module.exports = __webpack_public_path__ + "assets/img/app_test.57a4b274.png";